import { ReactNode } from 'react';

import {
  FeatureFlagsFragmentFragment,
  UserFeatureAccessType,
} from '@/generated';
import NotFound from '@/pages/NotFound';
import { useSession } from '@/providers/SessionProvider/SessionProvider';
import { isFeatureAccessible } from '@/utils/app-utils';
import { MaybeArray } from '@/utils/globalTypes';

export type FeatureFlagType = keyof FeatureFlagsFragmentFragment;

interface IWithFeatureAccess {
  children?: ReactNode;
  featureAccessType?: UserFeatureAccessType;
  featureFlag?: MaybeArray<FeatureFlagType>;
  fallbackComponent?: ReactNode;
}
const WithFeatureAccess = ({
  children,
  featureAccessType = UserFeatureAccessType.Release,
  featureFlag,
  fallbackComponent,
}: IWithFeatureAccess) => {
  const { currentUser, currentClient, isCurrentClientLoading } = useSession();

  if (isCurrentClientLoading) {
    return null;
  }

  let hasFeatureFlag: boolean;

  if (Array.isArray(featureFlag)) {
    hasFeatureFlag = featureFlag.some((flag) => currentClient?.[flag]);
  } else if (featureFlag) {
    hasFeatureFlag = !!currentClient?.[featureFlag];
  } else {
    hasFeatureFlag = true;
  }

  if (
    currentUser &&
    isFeatureAccessible(currentUser.featureAccess, featureAccessType) &&
    hasFeatureFlag
  ) {
    return children;
  } else if (currentUser && fallbackComponent && !hasFeatureFlag) {
    return fallbackComponent;
  }
  return <NotFound />;
};
export default WithFeatureAccess;
